
import sulu from '@razlet/sulu-sdk/lib/mixins/sulu';
import { rzButton, rzModalWindowMobile, rzIconFood, rzIconWifi, rzIconTv, rzIconNewspaper } from '@razlet/ui';
import PhotoSlider from '~/components/photo-slider';

export default {
  name: 'lounge',
  layout: 'index',
  components: {
    rzButton,
    PhotoSlider,
    rzModalWindowMobile,
    rzIconFood, 
    rzIconWifi, 
    rzIconTv, 
    rzIconNewspaper,
  },
  mixins: [sulu],
  data() {
    return {
      images: ['foto1', 'foto2', 'foto3', 'foto4', 'foto5', 'foto6', 'foto7', 'foto8'],
      isGallery: false,
      options: [
        { icon: 'rz-icon-food', label: 'Шведский стол: закуски, чай, кофе и прохладительные напитки' },
        { icon: 'rz-icon-wifi', label: 'Бесплатный интернет (Wi-Fi)' },
        { icon: 'rz-icon-newspaper', label: 'Пресса' },
        { icon: 'rz-icon-tv', label: 'ТВ' },
      ],
    };
  },
  head() {
    const links = this.images.map(url => ({
      rel: 'preload',
      as: 'image',
      href: `/lounge/${url}.webp`,
    }));

    return { link: links };
  },
};
